import { ImageBackground, View, type ViewStyle, StyleSheet } from 'react-native'
import type { PropsWithChildren } from 'react'
import { mesaColorNames, typography, fontFamilies } from '@/src/common/theme'

export function CardBack({
  style: otherStyles,
  imageBackgroundStyle,
  frozen,
  children,
}: {
  style?: ViewStyle
  imageBackgroundStyle?: ViewStyle
  frozen: boolean
} & PropsWithChildren) {
  return (
    <View style={otherStyles}>
      <ImageBackground
        style={imageBackgroundStyle}
        imageStyle={{ borderRadius: imageBackgroundStyle?.borderRadius }}
        source={require('@/src/assets/images/card_back.png')}
        blurRadius={frozen ? 8 : 0}
        resizeMode="cover"
        resizeMethod="scale"
      >
        {children}
        <View style={styles.footerContainer}></View>
      </ImageBackground>
    </View>
  )
}

const styles = StyleSheet.create({
  cardContent: {
    flex: 1,
    justifyContent: 'flex-start',
    paddingTop: 65,
    paddingLeft: 15,
    gap: 8,
  },
  cardInfoText: {
    color: mesaColorNames['Mesa - Brand/Secondary #223843'],
    textAlign: 'left',
    ...typography['paragraph/lg'],
  },
  expiryCvvContainer: {
    flexDirection: 'row',
    marginTop: 12,
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 50,
  },
  expiryContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  cvvContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  labelText: {
    color: mesaColorNames['Mesa - Brand/Secondary #223843'],
    fontFamily: fontFamilies['PlusJakartaSans-Bold'],
    fontWeight: 700,
    fontSize: 10,
    lineHeight: 15,
    textTransform: 'uppercase',
  },
  footerContainer: {
    marginTop: 20,
  },
  duplicateContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
})

export { styles as cardBackStyles }
